import { render, staticRenderFns } from "./Estudante-kilamba.vue?vue&type=template&id=30dd4144&scoped=true&"
import script from "./Estudante-kilamba.vue?vue&type=script&lang=js&"
export * from "./Estudante-kilamba.vue?vue&type=script&lang=js&"
import style0 from "./Estudante-kilamba.vue?vue&type=style&index=0&id=30dd4144&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd4144",
  null
  
)

export default component.exports